<section class="tax-calculation-wrapper">
  <section class="tax-calculation">
    <h1 class="tax-heading" [innerHTML]="'VAT_WHT_CALCULATION.HEADING.TITLE' | translate"></h1>

    <form class="tax-calculation-form" [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">
      <label class="radio-wrapper">
        <!-- ราคาไม่รวม VAT -->
        <div>
          <input id="female" type="radio" value="No" formControlName="priceIncludingVat" />
          <label for="female"> {{ 'VAT_WHT_CALCULATION.FORM.PRICE_NOT_INCLUDING_VAT' | translate }}</label>
        </div>

        <!-- ราคารวม VAT -->
        <div>
          <input id="male" type="radio" value="Yes" formControlName="priceIncludingVat" />
          <label for="male">{{ 'VAT_WHT_CALCULATION.FORM.PRICE_INCLUDING_VAT' | translate }}</label>
        </div>
      </label>

      <div class="input-group mb-3">
        <input class="form-control" type="number" formControlName="price" placeholder="ราคา" />
        <span class="input-group-text custom-border-left-radius">฿</span>
      </div>

      <div class="vat-tax-group">
        <!-- ภาษีมูลค่าเพิ่ม-->
        <div>
          <label> {{ 'VAT_WHT_CALCULATION.FORM.VAT' | translate }}</label>
          <div class="input-group mb-3">
            <select class="custom-select" (change)="selectedVatDropdown($event)" formControlName="vat">
              <option *ngFor="let vat of vatList" value="{{ vat.value }}"> {{ vat.name }}</option>
            </select>
          </div>
        </div>

        <!-- หักภาษี ณ ที่จ่าย -->
        <div>
          <label> {{ 'VAT_WHT_CALCULATION.FORM.WHT' | translate }}</label>
          <div class="input-group mb-3">
            <input class="form-control" type="number" formControlName="wht" />
            <span class="input-group-text custom-border-left-radius">%</span>
          </div>
        </div>
      </div>

      <button class="button-submit" type="submit" [disabled]="myForm.invalid">{{
        'VAT_WHT_CALCULATION.FORM.CALCULATE' | translate
      }}</button>

      <div *ngIf="calculateResultList.totalValue > 0" (click)="clearValue()" class="clear-button" type="text">{{
        'VAT_WHT_CALCULATION.FORM.RESET' | translate
      }}</div>
    </form>

    <div
      [ngClass]="{ show: calculateResultList.totalValue > 0, hide: calculateResultList.totalValue === 0 }"
      class="display-result-wrapper"
    >
      <h6>{{ 'VAT_WHT_CALCULATION.SHOW_RESULT.RESULT' | translate }}</h6>
      <div class="list-wrapper">
        <div class="list-title">{{ 'VAT_WHT_CALCULATION.SHOW_RESULT.PRICE_BEFORE_VAT' | translate }}</div>
        <div class="list-value">{{ calculateResultList.originalPrice | number: '1.2-2' }}</div>
      </div>

      <div class="list-wrapper">
        <div class="list-title"
          ><span [innerHTML]="'VAT_WHT_CALCULATION.SHOW_RESULT.VAT' | translate"> </span> {{ percentFromInput.vat }}%
        </div>
        <div class="list-value">{{ calculateResultList.vatResult | number: '1.2-2' }}</div>
      </div>

      <div class="list-wrapper">
        <div class="list-title">{{ 'VAT_WHT_CALCULATION.SHOW_RESULT.PRICE_INCLUDING_VAT' | translate }}</div>
        <div class="list-value">{{
          calculateResultList.originalPrice + calculateResultList.vatResult | number: '1.2-2'
        }}</div>
      </div>

      <div class="list-wrapper">
        <div class="list-title">
          <span [innerHTML]="'VAT_WHT_CALCULATION.SHOW_RESULT.WHT' | translate"> </span> {{ percentFromInput.wht }}%
        </div>
        <div class="list-value">({{ calculateResultList.whtResult | number: '1.2-2' }})</div>
      </div>

      <div class="list-wrapper">
        <div class="list-title">{{ 'VAT_WHT_CALCULATION.SHOW_RESULT.TOTAL' | translate }}</div>
        <div class="list-value">{{ calculateResultList.totalValue | number: '1.2-2' }}</div>
      </div>
    </div>
  </section>

  <!-- table -->
  <section class="table-wrapper">
    <h1 class="desktop" [innerHTML]="'VAT_WHT_CALCULATION.HEADING.TABLE_TITLE_DESKTOP' | translate"></h1>
    <h1 class="mobile" [innerHTML]="'VAT_WHT_CALCULATION.HEADING.TABLE_TITLE_MOBILE' | translate"></h1>
    <table class="styled-table">
      <thead>
        <tr>
          <th>{{ 'VAT_WHT_CALCULATION.TABLE.EXPENSE' | translate }}</th>
          <th>{{ 'VAT_WHT_CALCULATION.TABLE.OPERATE_INCOME_TAX' | translate }}</th>
          <th>{{ 'VAT_WHT_CALCULATION.TABLE.PERSONAL_INCOME_TAX' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of tableList">
          <tr>
            <td>{{ item.TEXT }}</td>
            <td>{{ item.OPERATE_INCOME_TAX }}</td>
            <td>{{ item.PERSONAL_INCOME_TAX }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </section>
</section>

<flowaccount-invite-to-use-section
  [customHeader]="customInviteSection"
  [customClassName]="'business-registration'"
  [customLink]="'https://auth.flowaccount.com/th/Account/Register'"
></flowaccount-invite-to-use-section>

<flowaccount-blog-swiper
  [page]="page.VatWhtCalculation"
  [lang]="translate.currentLang"
  [customHeader]="customHeader"
  [customClassName]="'vat-wht-calculation'"
></flowaccount-blog-swiper>
